export default __webpack_public_path__ + "assets/e8199dc7e34a5708234ba0ed2a08bd9b/10.jpg";